import React from 'react';
import { Col, Row } from 'react-bootstrap';
import WelcomeNote from './welcomeNote/WelcomeNote';
import Stats from './stats/Stats';
import JobAnalysis from './analysis/JobAnalysis';
import AcquisitionsProgressCard from './acquisitions/progress/AcquisitionsProgressCard';
import AcquisitionsProfileCard from './acquisitions/profile/AcquisitionsProfileCard';
import Interview from './interview/Interview';
import 'assets/scss/modules/recruiterDashboard.scss';
import { useFindRecruiterDashboardStatsQuery } from 'service/recruiterQuery/recruiterQuery';
import { DataType } from './recruiterDashboard.type';

function RecruiterDashboard() {
  const { data = {} } = useFindRecruiterDashboardStatsQuery('');

  return (
    <div className="pb-5">
      <Row className="g-3">
        <Col xs={12} xl={9}>
          <WelcomeNote />
          <Stats data={data as DataType} />
          <Row className="g-3">
            <Col xs={12} xl={8}>
              <JobAnalysis data={(data as DataType).stats} />
            </Col>
            <Col xs={12} xl={4}>
              <AcquisitionsProgressCard
                data={(data as DataType).acquisitions}
              />
              <AcquisitionsProfileCard data={(data as DataType).profiles} />
            </Col>
          </Row>
        </Col>
        <Col xs={12} md={3}>
          <Interview />
        </Col>
      </Row>
    </div>
  );
}

export default RecruiterDashboard;
